<template>
    <div>
        <button class="tb-button tb-button--blue" v-if="!show_create_form" @click.prevent="show_create_form = true">
            ADD UPDATE
        </button>

         <b-form @submit.prevent="onSubmit()" v-if="show_create_form" class="mt-3">
            <b-form-group>
                <label>
                    Title
                </label>
                
                <b-form-input
                    class="tb-form-field"
                    type="text"
                    v-model="form.title"
                    required>    
                </b-form-input>

                <label>
                    Body
                </label>

                <div class="wysiwyg-boxed">
                    <vue-editor
                        v-model="form.body"
                        :editorToolbar="
                        [
                            ['bold', 'italic', 'underline'],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['code-block'],
                            [{align: ''}, {align: 'center'}, {align: 'right'}]
                        ]"></vue-editor>
                </div>


                <!-- <b-form-textarea
                    v-model="form.body"
                    required>    
                </b-form-textarea> -->
            </b-form-group>

            <b-button type="submit" class="tb-button tb-button--small tb-button--blue mr-2">
                Submit
            </b-button>

             <b-button class="tb-table__button tb-table__button--blue" @click.prevent="show_create_form = false">
                 Cancel
             </b-button>
        </b-form>
    </div>
</template>

<script>
    import { VueEditor } from "vue2-editor";

    export default {
        props: ['eventId'],

        components: {
            VueEditor
        },

        data() {
            return {
                form: {
                    event_id: this.eventId,
                    title: "",
                    body: ""
                },
                show_create_form: false
            }
        },

        methods: {
            onSubmit() {
                this.$emit('created', { ...this.form });
                this.clear();
                this.show_create_form = false;
            },

            clear() {
                this.form.title = "";
                this.form.body = "";
            }
        }
    }
</script>

<style scoped>
    .form-group {
        margin: 0;
        margin-bottom: 10px;
    }

    textarea {
        margin-bottom: 10px;
    }
</style>